module.exports = __webpack_public_path__ + "static/media/MonumentExtended-Regular.73b9994b.otf";